<div class="content">
  <br />
  دکمه زیر را فشار دهید و در ادامه <br /><strong>Add to homescreen</strong>.
  <div class="full-width">
    <mat-icon>arrow_downward</mat-icon>
  </div>
</div>
<button class="btn-close" mat-icon-button (click)="close()" aria-label="Close">
  <mat-icon>close</mat-icon>
</button>
